export default __webpack_public_path__ + "static/banner-img2-d8740154d05f40bcb1a2ffba6427cff9.png";